import { CylinderGeometry, LatheGeometry, SphereGeometry, Vector2 } from 'three';
import type { BufferGeometry } from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';

/**
 * A limb segment along +Z from its joint: a tapered tube with round ends, so it can be pointed at the next joint with
 * lookAt and stretched along Z. Radii at the start and the end; length 1 (scale it).
 */
export function limb(startRadius: number, endRadius: number, radialSegments = 18): BufferGeometry {
  const tube = new CylinderGeometry(endRadius, startRadius, 1, radialSegments, 1, true);
  tube.rotateX(Math.PI / 2);
  tube.translate(0, 0, 0.5);
  const start = new SphereGeometry(startRadius, radialSegments, 10);
  const end = new SphereGeometry(endRadius, radialSegments, 10);
  end.translate(0, 0, 1);
  return mergeGeometries([tube, start, end].map((g) => g.toNonIndexed()))!;
}

/** A body of revolution from a profile of (radius, height) points, squashed front to back by depth. */
export function lathe(profile: [number, number][], depth: number, segments = 40): BufferGeometry {
  const geometry = new LatheGeometry(profile.map(([r, y]) => new Vector2(r, y)), segments);
  geometry.scale(1, 1, depth);
  geometry.computeVertexNormals();
  return geometry;
}

/** A sphere squashed or stretched on each axis. */
export function blob(x: number, y: number, z: number, detail = 24): BufferGeometry {
  const geometry = new SphereGeometry(1, detail, Math.round(detail * 0.7));
  geometry.scale(x, y, z);
  return geometry;
}
